/**
 * Cadence's keyboard focus ring for @sai/ui sidebar controls (#14982).
 *
 * sai-ui's `SidebarMenuButton` and `SidebarTrigger` replace the ring with
 * `focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:shadow-focus`,
 * and `shadow-focus` emits no CSS here (AGENTS.md § Design System;
 * docs/design-system/SAI_UI_TOKEN_MAP.md), so a focused sidebar control drew
 * nothing at all. These restore the ring the sai adapters use
 * (`ring-stroke-attention`, as `src/components/ui/button.tsx`).
 *
 * The offset stays at sai's `ring-offset-0`: sidebar rows sit on a background
 * that varies (the sidebar grey, the active wash), so there is no offset
 * colour to name — the `sort-header.tsx` camp of #13254 — and an uncoloured
 * `ring-offset-2` is the white band #13254 removed.
 */

/** Menu rows: inset, so the collapsed rail's `overflow-hidden` cannot clip it. */
export const SIDEBAR_ROW_FOCUS_RING =
  'focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-stroke-attention focus-visible:ring-offset-0'

/** Header controls (the collapse trigger, the logo link). */
export const SIDEBAR_CONTROL_FOCUS_RING =
  'focus-visible:ring-2 focus-visible:ring-stroke-attention focus-visible:ring-offset-0'
